var map = {
	"./姜燕.png": "d3e7",
	"./徐诗.png": "e031",
	"./李守宇.png": "cebd",
	"./熊钢.png": "9e6d",
	"./袁锋.png": "7789",
	"./金天.png": "8261",
	"./陈宇雷.png": "9294"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0482";